import { render, staticRenderFns } from "./positionDetalis.vue?vue&type=template&id=e5b20b1c&scoped=true&"
import script from "./positionDetalis.vue?vue&type=script&lang=js&"
export * from "./positionDetalis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b20b1c",
  null
  
)

export default component.exports